module.exports = __webpack_public_path__ + "img/android.fe017f84.svg";